import { IconColor } from '../components/Shared/Icon/icon-color.enum';
import { IconMotif } from '../components/Shared/Icon/icon-motif.enum';
import { IconVariant } from '../components/Shared/Icon/icon-variant.enum';
import { TransportMode } from '../models/transport-mode.enum';
import { TranslationService } from '../services/translation.service';

const translationDictionary = [
  { transportMode: TransportMode.bus, translationKey: 'common.bus' },
  { transportMode: TransportMode.ferry, translationKey: 'common.ferry' },
  { transportMode: TransportMode.train, translationKey: 'common.train' },
  { transportMode: TransportMode.tram, translationKey: 'common.tram' },
  { transportMode: TransportMode.taxi, translationKey: 'common.taxi' },
  { transportMode: TransportMode.walk, translationKey: 'common.transportmodes.walk' },
  { transportMode: TransportMode.bike, translationKey: 'common.bike' },
];

export class TransportModeHelper {
  private static readonly allModes: TransportMode[] = Object.values(TransportMode) as TransportMode[];

  public static get all(): TransportMode[] {
    return TransportModeHelper.allModes;
  }

  public static parse(value: string): TransportMode {
    if (Object.values(TransportMode).includes(value as TransportMode)) {
      return value as TransportMode;
    }
    return TransportMode.unknown;
  }

  public static translate(transportMode: string): string {
    if (!transportMode) {
      return '';
    }
    if (translationDictionary.findIndex((obj) => obj.transportMode === transportMode) < 0) {
      return transportMode;
    }

    let result = '';
    const translationKeyValue = translationDictionary.find((obj) => obj.transportMode === transportMode);
    if (translationKeyValue) {
      result = TranslationService.get(translationKeyValue.translationKey);
    }

    return result;
  }

  public static getSortIndexForTransportMode(tm: TransportMode): number {
    const sortValues = {
      [TransportMode.tram]: 0,
      [TransportMode.ferry]: 1,
      [TransportMode.train]: 2,
      [TransportMode.bus]: 3,
      [TransportMode.taxi]: 4,
      [TransportMode.walk]: 4,
      [TransportMode.bike]: 4,
      [TransportMode.car]: 4,
      [TransportMode.none]: 99,
      [TransportMode.unknown]: 99,
    };
    return sortValues[tm];
  }

  public static getIcon(transportMode: TransportMode): { motif: IconMotif; variant?: IconVariant; color?: IconColor } {
    switch (transportMode) {
      case TransportMode.bus:
        return { motif: IconMotif.Bus };
      case TransportMode.car:
        return { motif: IconMotif.Car };
      case TransportMode.train:
        return { motif: IconMotif.Train };
      case TransportMode.ferry:
        return { motif: IconMotif.Ferry };
      case TransportMode.tram:
        return { motif: IconMotif.Tram };
      case TransportMode.taxi:
        return { motif: IconMotif.Taxi };
      case TransportMode.walk:
        return { motif: IconMotif.Walk };
      case TransportMode.bike:
        return { motif: IconMotif.Bike };
      default:
        return { motif: IconMotif.Exclamation, variant: IconVariant.Circle }; // Default icon for unknown transport modes
    }
  }
}
